import { EntityHeaderBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const entityFilterDataRef =
  EntityHeaderBlueprint.dataRefs.filterFunction;
